import { render } from "./UsersTable.vue?vue&type=template&id=ba2dd070&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"

import "./UsersTable.vue?vue&type=style&index=0&id=ba2dd070&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba2dd070"

export default script